import { render, staticRenderFns } from "./ModelEdit.vue?vue&type=template&id=49a5313b&scoped=true"
import script from "./ModelEdit.vue?vue&type=script&lang=js"
export * from "./ModelEdit.vue?vue&type=script&lang=js"
import style0 from "./ModelEdit.vue?vue&type=style&index=0&id=49a5313b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a5313b",
  null
  
)

export default component.exports